/*global MOVE_DATA, localStorage*/
import { loadMaps } from "maps";
import { getViewType } from "../../shared_critical/helper";
import { contains } from 'underscore';
import { AB_SRP_LAYOUT_COOKIE_MAP, AB_SRP_LAYOUT_COOKIE_MIXED } from '../basecamp/constants';


// preload map assets
// warning -- this will not render your map
// rendering requires initialization of Component
// see ./shared/views/_map_view.js
// if ($.cookie('srp.viewType') === "map") {
//     loadMaps("rdc-srp");
// }

if (contains([AB_SRP_LAYOUT_COOKIE_MAP, AB_SRP_LAYOUT_COOKIE_MIXED], getViewType())){
  loadMaps("rdc-srp");
}



// WEBPACK FOOTER //
// ./srp/critical_components/_preload_maps.js